.
<template>
    <video
        ref="container"
        class="th-video"
        :autoplay="autoplayComputed ? true : undefined"
        :loop
        :muted
        :src="uri"
        :type="video.type"
        @click="playPause"
    ></video>
</template>

<script setup lang="ts">
import type { CatalogueVideo } from '@/graphql/api'
import { computed, type Ref, ref } from 'vue'
import { isIOS } from '@vueuse/core'

const props = withDefaults(
    defineProps<{
        video: CatalogueVideo
        autoplay?: boolean
        muted?: boolean
        loop?: boolean
        enableTapToPlay?: boolean
    }>(),
    {
        muted: true,
        loop: true,
    }
)

const autoplayComputed = computed(() => {
    if (isIOS) {
        return false
    }

    return props.autoplay
})

const uri = computed(() => {
    if (isIOS) {
        return `${props.video.uri}#t=0.1`
    }

    return props.video.uri
})

const container: Ref<HTMLVideoElement | null> = ref(null)

function playPause(): void {
    if (!props.enableTapToPlay) {
        return
    }

    const video = container.value

    if (!video) {
        return
    }

    if (video.paused) {
        video.play()
    } else {
        video.pause()
    }
}
</script>

<style scoped lang="scss">
.th-video {
    display: block;
    width: 100%;
    height: auto;
    object-fit: cover;
    object-position: center;
}
</style>
